import * as types from './types';
import _ from 'lodash';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  consolidateData: {
    ConsolidateManagerModel: [],
    OrderConsolidatedVerification: null,
    WHAssociation: [],
  },
  consolidateDataLoading: false,
  consolidateDataError: null,
  consolidateApiModel: null,
  consolidateProcessLoading: false,
  consolidateProcessError: null,
  submitted: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_CONSOLIDATE_ORDER_LOADING:
      return {
        ...state,
        consolidateDataLoading: action.payload,
      };
    case types.GET_CONSOLIDATE_ORDER_LOADING_ERROR:
      const consolidateOrderErrorResponse = action.payload.response;
      if (
        _.has(consolidateOrderErrorResponse, 'data.Errors') &&
        consolidateOrderErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          consolidateDataError: consolidateOrderErrorResponse.data.Errors,
        };
      }
      return {
        ...state,
        consolidateDataError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching consolidate Order(s). Please try again',
        },
      };
    case types.SET_CONSOLIDATE_DATA:
      return {
        ...state,
        consolidateData: action.payload,
      };
    case types.SET_CONSOLIDATE_API_MODEL_DATA:
      return {
        ...state,
        consolidateApiModel: action.payload,
      };
    case types.PROCESS_CONSOLIDATE_ORDER_LOADING:
      return {
        ...state,
        consolidateProcessLoading: action.payload,
      };
    case types.PROCESS_CONSOLIDATE_ORDER_LOADING_ERROR:
      const processConsolidateOrderResponse = action.payload.response;
      if (
        _.has(processConsolidateOrderResponse, 'data.Errors') &&
        processConsolidateOrderResponse.data.Errors.length
      ) {
        return {
          ...state,
          consolidateProcessError: processConsolidateOrderResponse.data.Errors,
        };
      }
      return {
        ...state,
        consolidateProcessError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while processing consolidate Order(s). Please try again',
        },
      };
    case types.CLEAR_CONSOLIDATE_ORDER_ERROR:
      return {
        ...state,
        consolidateProcessError: null,
        consolidateDataError: null,
        submitted: false,
      };
    case types.PROCESS_CONSOLIDATE_DATA:
      return {
        ...state,
        submitted: true,
      };
    case types.CLEAR_ORDER_CONSOLIDATE_VERIFICATION_MSG:
      const consolidateData = { ...state.consolidateData };
      consolidateData.OrderConsolidatedVerification = null;
      return {
        ...state,
        consolidateData,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/consolidate/reducer.js